var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { WithImage } from "@irati/ui/src/Modal";
import image from "@irati/ui/images/mfa.png";
var ProfileNoBorder = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n\n  ", "\n"], ["\n  position: absolute;\n\n  ",
    "\n"])), function (_a) {
    var size = _a.size;
    return "\n    top: -" + (size / 2 + 5) + "px;\n    width: " + size + "px;\n    height: " + size + "px;\n  ";
});
var ModalHeader = function (_a) {
    var children = _a.children, size = _a.size;
    return (React.createElement(WithImage, { size: size, image: image },
        React.createElement(ProfileNoBorder, { size: size }, children)));
};
export default ModalHeader;
var templateObject_1;
